var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0452 19.2053C23.2558 19.4162 23.3742 19.7022 23.3742 20.0003C23.3742 20.2984 23.2558 20.5844 23.0452 20.7953L18.8032 25.0388C18.5921 25.2497 18.3059 25.3682 18.0075 25.3681C17.7091 25.3681 17.423 25.2495 17.212 25.0384C17.0011 24.8274 16.8826 24.5412 16.8827 24.2428C16.8828 23.9444 17.0014 23.6582 17.2124 23.4473L20.6594 20.0003L17.2124 16.5533C17.0074 16.3412 16.8939 16.0571 16.8963 15.7621C16.8987 15.4671 17.0169 15.1849 17.2254 14.9762C17.4339 14.7676 17.716 14.6491 18.0109 14.6464C18.3059 14.6437 18.5901 14.757 18.8024 14.9618L23.0459 19.2046L23.0452 19.2053Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.bff580dc6af0bca2df6e70f51bfdf3e2.svg";
export { ForwardRef as ReactComponent };